import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Label } from 'globals/store/events.data';
import { IconComponent } from 'src/app/components/icon/icon.component';

@Component({
    selector: 'label-dots',
    template: `
<div class="label-holder" *ngIf="labels.length">
  <div class="label" *ngFor="let label of labels; first as first; index as index; trackBy: trackById"
    [ngClass]="{first:first}" [ngStyle]="{zIndex: 5-index, backgroundColor: label.color }"><icon *ngIf="moreThan4 && index === 3" matIcon="more_horiz"></icon></div>
</div>
`,
    styles: [`
.label-holder { display: flex; flex-wrap: nowrap; }
.label-holder .label { width:12px; height:12px; border-radius:6px; margin: auto 0 auto -2px; }
.label-holder .label icon { color:#999; font-size:12px; width:12px; height:12px; border-radius:6px; vertical-align: top; }
  `],
    standalone: true,
    imports: [CommonModule, IconComponent],
})
export class LabelDotsComponent implements OnChanges {
  @Input() labelMap: { [labelId: string]: Label } 
  @Input() labelIds: string[]
  labels: Label[] = []
  moreThan4 = false

  ngOnChanges(changes: SimpleChanges) {
    if (!this.labelMap || !this.labelIds) {
      this.labels = []
      this.moreThan4 = false
    } else {
      this.labels = this.labelIds.map(id => this.labelMap[id]).filter(l => l).reverse()
      this.moreThan4 = this.labels.length > 4
      this.labels = this.labels.slice(0,4)
    }
  }

  trackById(index, label: Label) {
    return label.id
  }


}

